import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { updatePatientZoomMeetingBillingNote } from "~/providers/api/patientZoomMeetingsService";
import { ReimbursementReportData } from "~/providers/utils/types/consultation/reimbursementReportTypes";

interface UseUpdatePatientBillingNoteProps {
  patientId: string;
  sessionId: string;
  showSuccessMessage?: boolean;
}

export const useUpdatePatientBillingNote = ({
  patientId,
  sessionId,
  showSuccessMessage,
}: UseUpdatePatientBillingNoteProps) => {
  const queryClient = useQueryClient();

  const { mutate: updatePatientBillingNoteMutation, isPending } = useMutation({
    mutationFn: (reportData: ReimbursementReportData) =>
      updatePatientZoomMeetingBillingNote({
        patientId,
        sessionId,
        data: reportData,
      }),
    onError: () =>
      toast.error(
        "We hit trouble updating the billing note. If the issue persists please reload the page!",
      ),
    onSuccess: async () => {
      showSuccessMessage && toast.success("Billing note updated successfully!");
      await queryClient.invalidateQueries({
        queryKey: ["getPatientZoomMeetingBillingNote", patientId, sessionId],
      });
    },
  });

  return { updatePatientBillingNoteMutation, isPending };
};
